<p>third-party-consignment-field works!</p>
<app-address-third-party-consignment-field></app-address-third-party-consignment-field>